import { useEffect, useState } from "react";
import { FileCheck, Save, Info } from "lucide-react";
import { toast } from "sonner";
import api from "@/lib/api";

export default function Tnc() {
  const [content, setContent] = useState("");
  const [gstLine, setGstLine] = useState("");
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    Promise.all([
      api.get("/tnc").then((r) => setContent(r.data?.content || "")),
      api.get("/settings/gst_mandatory_line").then((r) => setGstLine(r.data?.value || "")),
    ]).catch(() => {}).finally(() => setLoading(false));
  }, []);

  const save = async () => {
    setSaving(true);
    try {
      await api.put("/tnc", { content });
      toast.success("T&C template updated");
    } catch (e) { toast.error(e?.response?.data?.detail || "Save failed"); }
    finally { setSaving(false); }
  };

  if (loading) return <div className="p-10 text-center text-slate-400">Loading…</div>;

  return (
    <div className="p-6 lg:p-8 max-w-5xl mx-auto" data-testid="tnc-page">
      <div className="flex items-center justify-between mb-6">
        <div>
          <h1 className="text-2xl font-bold text-slate-900 flex items-center gap-2"><FileCheck size={22} className="text-orange-600" /> T&C Template</h1>
          <p className="text-sm text-slate-500 mt-0.5">Terms & conditions that appear on every Excel quotation export.</p>
        </div>
        <button onClick={save} disabled={saving} className="px-4 py-2 bg-orange-600 hover:bg-orange-700 disabled:bg-orange-300 text-white text-sm font-semibold rounded-md flex items-center gap-1.5" data-testid="tnc-save">
          <Save size={14} /> {saving ? "Saving…" : "Save Template"}
        </button>
      </div>

      <div className="bg-white border border-slate-200 rounded-lg p-5 mb-4">
        <label className="block text-xs font-medium text-slate-600 mb-2">T&C Content (supports **bold** markdown)</label>
        <textarea
          value={content}
          onChange={(e) => setContent(e.target.value)}
          rows={24}
          className="w-full px-4 py-3 border border-slate-300 rounded-md text-sm font-mono focus:outline-none focus:ring-2 focus:ring-orange-500"
          data-testid="tnc-textarea"
        />
      </div>

      <div className="bg-amber-50 border border-amber-200 rounded-lg p-4 flex gap-3">
        <Info size={18} className="text-amber-600 flex-shrink-0 mt-0.5" />
        <div className="text-sm">
          <div className="font-semibold text-amber-900 mb-1">Non-negotiable GST line (always appended)</div>
          <div className="text-amber-800 italic">“{gstLine}”</div>
          <div className="text-xs text-amber-700 mt-1.5">This line is automatically appended to every Excel export regardless of what's above. To edit it, go to Settings → <code>gst_mandatory_line</code>.</div>
        </div>
      </div>
    </div>
  );
}
